module.exports = __webpack_public_path__ + "img/2.d6ab77d9.png";